/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:48 GMT
 *
 */

import PaletteIconClose from '@telus-uds/palette-allium/build/rn/icons/Close'
const theme = {
  appearances: {
    maxWidth: {
      description: 'Whether a modal should expand responsively to the maximum of 8 layout columns width',
      type: 'state',
      values: [ true ]
    },
    viewport: {
      description: 'The size label for the current screen viewport based on the current screen width',
      type: 'state',
      values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
    },
    width: {
      description: 'The width of the modal',
      type: 'state',
      values: [ 's', 'm', 'l', 'xl' ]
    }
  },
  rules: [
    {
      if: { viewport: [ 'xs', 'sm' ] },
      tokens: {
        direction: 'column',
        height: '100%',
        marginLeft: 24,
        marginRight: 24,
        paddingBottom: 24,
        paddingLeft: 24,
        paddingRight: 24,
        paddingTop: 24
      }
    },
    {
      if: { viewport: [ 'md', 'lg', 'xl' ] },
      tokens: {
        containerPaddingBottom: 32,
        containerPaddingTop: 32,
        direction: 'row',
        maxWidth: 576
      }
    },
    {
      if: { viewport: [ 'md', 'lg', 'xl' ], width: 's' },
      tokens: {
        containerPaddingBottom: 32,
        containerPaddingTop: 32,
        maxWidth: 320
      }
    },
    {
      if: { viewport: [ 'md', 'lg', 'xl' ], width: 'm' },
      tokens: {
        containerPaddingBottom: 32,
        containerPaddingTop: 32,
        maxWidth: 480
      }
    },
    {
      if: { viewport: [ 'lg', 'xl' ], width: 'l' },
      tokens: {
        containerPaddingBottom: 32,
        containerPaddingTop: 32,
        maxWidth: 630
      }
    },
    {
      if: { viewport: 'xl', width: 'xl' },
      tokens: {
        containerPaddingBottom: 32,
        containerPaddingTop: 32,
        maxWidth: 768
      }
    },
    {
      if: { maxWidth: true, viewport: 'md' },
      tokens: {
        containerPaddingLeft: 16,
        containerPaddingRight: 16,
        maxWidth: 480
      }
    },
    {
      if: { maxWidth: true, viewport: 'lg' },
      tokens: {
        containerPaddingLeft: 16,
        containerPaddingRight: 16,
        maxWidth: 630
      }
    },
    {
      if: { maxWidth: true, viewport: 'xl' },
      tokens: {
        containerPaddingLeft: 16,
        containerPaddingRight: 16,
        maxWidth: 768
      }
    }
  ],
  tokens: {
    backdropColor: 'rgba(244, 244, 247, 0.97)',
    backdropOpacity: 1,
    backgroundColor: '#ffffff',
    borderColor: '#e3e6e8',
    borderRadius: 4,
    borderWidth: 0,
    cancelButtonColor: '#2b8000',
    closeIcon: PaletteIconClose,
    closeIconColor: '#414547',
    closeIconSize: 16,
    closePadding: 4,
    containerPaddingBottom: 0,
    containerPaddingLeft: 0,
    containerPaddingRight: 0,
    containerPaddingTop: 0,
    contentPaddingBottom: 0,
    contentPaddingTop: 0,
    direction: 'row',
    footerTopWidth: 0,
    gap: 16,
    headingBorderBottomWidth: 0,
    headingColor: '#414547',
    headingPaddingRight: 24,
    headingPaddingTop: 8,
    height: null,
    marginLeft: 32,
    marginRight: 32,
    maxWidth: '100%',
    paddingBottom: 24,
    paddingLeft: 32,
    paddingRight: 32,
    paddingTop: 24,
    shadow: {
      blur: 8,
      color: 'rgba(0, 0, 0, 0.1)',
      inset: false,
      offsetX: 0,
      offsetY: 4,
      spread: 0
    },
    subHeadingMarginTop: 8
  }
}
export default theme
